@import '../../style/index';

$sizes: $xxlarge, $xlarge, $large, $medium, $small, 100px;

:host {
  display: inline-block;
  height: inherit;
  width: 100%;

  @include responsive($sizes);

  &[full-height] {
    height: 100%;
  }

  .image-container {
    margin: 0;

    &--full-height {
      height: 100%;
    }
  }

  .margin-top {
    @include component-margin();
  }

  .image {
    position: relative;
    width: 100%;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;

    .filters {
      pointer-events: none;

      .brightness,
      .saturation,
      .blur {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
      }

      .brightness {
        background-color: legacy-color-theme(shared, color--white);
      }

      .saturation {
        background-color: legacy-color-theme(shared, color--black);
      }

      .blur {
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
        // stylelint-disable-next-line
        filter: blur(10px);
      }
    }

    img {
      // the image is being stretched to fit the parent on purpose
      // not setting height so that the image always has the correct ratio
      width: 100%;
      // but it's hidden to preserve the "right-click" functionality
      // the actual image being shown is on the parent element
      opacity: 0;
      // to prevent the image beeing smaller than the background
      height: 100%;
    }

    &--fullscreen {
      width: 100vw;
      margin-left: calc(50% - 50vw);
    }

    &--original {
      overflow: auto;
      background-size: contain;

      img {
        height: auto;
        display: block;
      }
    }

    &--full-height {
      height: 100%;
      background-size: cover;

      img {
        object-fit: cover;
      }
    }
  }

  .description {
    @include copy-secondary;

    margin-top: rem-calc(12px);
    margin-bottom: 0;
    max-width: rem-calc(752px);
    color: legacy-color-theme(light, color-text--secondary);

    @include large-up {
      max-width: rem-calc(880px);
    }

    @include xlarge-up {
      max-width: rem-calc(960px);
    }
  }

  .copyright {
    @include copy-footnotes;

    margin-top: rem-calc(4px);
    margin-bottom: 0;
    color: legacy-color-theme(light, color-text--secondary);
  }
}
